export default __webpack_public_path__ + "baafadd7f87b83a8ace50c132c89274f.png";